import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { AppStoreBadgesOfficial } from "./AppStoreBadgesOfficial";

export function ConnectAppDownloadStrip() {
  const { t } = useTranslation("common");

  const trustPoints = [
    t("trustHdCalls"),
    t("trustNoExpiry"),
    t("trustNoContracts"),
  ];

  return (
    <section id="download" className="bg-muted/30 border-y scroll-mt-16">
      <div className="container mx-auto px-4 py-12 sm:py-16">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-3">
            {t("downloadHeadline")}
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground mb-8 max-w-xl mx-auto">
            {t("downloadSubhead")}
          </p>

          <AppStoreBadgesOfficial className="mb-10" />

          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
            {trustPoints.map((point) => (
              <li key={point} className="inline-flex items-center gap-2">
                <Check className="h-4 w-4 text-primary" aria-hidden="true" />
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
